import commonApi from './CommonApi.js';

export default {
    newItem: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/new', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getAll: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/getAll', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getById: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/getById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    search: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/search', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getActive: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/getActive', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    create: async (viewModel) => {
        return await commonApi().post('/withdrawal-arbitration', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    edit: async (viewModel) => {
        return await commonApi().put('/withdrawal-arbitration', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    delete: async (parameters) => {
        return await commonApi().delete('/withdrawal-arbitration', { params: parameters })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getDelegations: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/getDelegations', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    generate: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/generate', { params: parameters, responseType: 'blob' })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getBySymbol: async (parameters) => {
        return await commonApi().get('/withdrawal-arbitration/get-by-symbol', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
}
